import { ref as f } from "vue";
import g from "lodash/clamp";
import d from "lodash/get";
import m from "lodash/isFunction";
import O from "lodash/isNil";
import { filterGroups as b, filterOptions as S, flattenOptions as u, not as p, createTaggableOption as y, isObject as o, isEmpty as n, flatAndStrip as V, calculateMinMenuWidthFromLabels as K, getNextWrappingIndex as a, sortData as v } from "./multiselect-helper.js";
import P from "./pendo-multiselect-props.js";
import { getScrollbarWidth as $, getBorderWidth as w } from "../../utils/dom.js";
import { unwrapElement as L } from "../../utils/utils.js";
const B = {
  name: "PendoMultiselectCore",
  mixins: [P],
  compatConfig: {
    RENDER_FUNCTION: !1
  },
  setup() {
    const e = f();
    function t(i) {
      e.value = i;
    }
    return { triggerRef: e, setTriggerRef: t };
  },
  render() {
    return this.$slots.default(this);
  },
  provide() {
    return {
      multiselect: this
    };
  },
  inject: {
    $form: {
      default: ""
    },
    $formItem: {
      default: ""
    }
  },
  data() {
    return {
      computedMenuWidth: this.minMenuWidth,
      inputValue: "",
      isFocused: !1,
      isOpen: !1,
      pointer: -1,
      selectedValuePointer: -1,
      shouldScrollToFocusedOption: !1,
      triggerWidth: 0
    };
  },
  computed: {
    computedPlaceholder() {
      return this.multiple ? this.placeholder : this.getOptionLabel(this.selectedValue) || this.placeholder;
    },
    filteredOptions() {
      const e = this.inputValue || "", t = e.toLowerCase().trim();
      let i = this.options.concat();
      if (this.internalSearch ? i = this.hasGroups ? b(
        t,
        this.labelKey,
        this.groupOptionsKey,
        this.groupLabelKey,
        this.formatOptionLabel
      )(i) : S(i, t, this.labelKey, this.formatOptionLabel) : i = this.hasGroups ? u(this.groupOptionsKey, this.groupLabelKey, this.valueKey, this.groupSelect)(i) : i, this.hideSelectedOptions && (this.hasGroups ? i = i.map((s) => {
        if (!s[this.groupOptionsKey] || !s[this.groupOptionsKey].length)
          return [];
        const l = s[this.groupOptionsKey].filter(p(this.isOptionSelected));
        return l.length ? {
          ...s,
          [this.groupLabelKey]: s[this.groupLabelKey],
          [this.groupOptionsKey]: l
        } : [];
      }) : i = i.filter(p(this.isOptionSelected))), this.taggable && e.length && this.isNewOption(e)) {
        const s = y({
          search: e,
          hasGroups: this.hasGroups,
          groupOptionsKey: this.groupOptionsKey,
          groupLabelKey: this.groupLabelKey,
          valueKey: this.valueKey
        });
        this.tagPosition === "bottom" ? i.push(s) : i.unshift(s);
      }
      if (this.sortBy || this.sortMethod) {
        let s;
        this.sortMethod && (s = this.sortMethod), this.sortBy && (s = (l, h) => v(l, h, this)), i = [...i].sort(s), this.hasGroups && i.forEach((l) => {
          !l[this.groupOptionsKey] || !l[this.groupOptionsKey].length || (l[this.groupOptionsKey] = [...l[this.groupOptionsKey]].sort(s));
        });
      }
      return i;
    },
    flattenedOptions() {
      return u(
        this.groupOptionsKey,
        this.groupLabelKey,
        this.valueKey,
        this.groupSelect
      )(this.filteredOptions);
    },
    hasGroups() {
      return this.options.some((e) => o(e) && e[this.groupOptionsKey]);
    },
    isDisabled() {
      const e = this.disabled || d(this, "$form.disabled", !1);
      return this.disableWhileLoading && this.loading || e;
    },
    isFullWidth() {
      return this.minTriggerWidth === "100%" || this.fullWidth;
    },
    isPlaceholderVisible() {
      return this.model.length && !n(this.selectedValue) ? !1 : !this.isOpen || !this.isSearchable;
    },
    isSearchable() {
      if (this.searchable === !1)
        return !1;
      if (this.searchable || this.taggable)
        return !0;
      if (this.searchThreshold)
        return this.optionCount > this.searchThreshold;
    },
    isSearchIconVisible() {
      return this.taggable || this.multiple ? !this.showSelectedValues : !!(this.isSearchable && this.isOpen);
    },
    isSelectedLabelVisible() {
      return !n(this.selectedValue) && !this.visibleSelectedValues.length && (!this.isOpen || !this.isSearchable);
    },
    allOptionsSelected() {
      if (!this.model.length)
        return !1;
      let e = this.options.concat();
      return this.hasGroups && (e = u(
        this.groupOptionsKey,
        this.groupLabelKey,
        this.valueKey,
        this.groupSelect
      )(e).filter((t) => t.type !== "group")), e.filter((t) => !this.isOptionSelected(t)).length === 0;
    },
    model() {
      return this.value || this.value === 0 ? Array.isArray(this.value) ? this.value : [this.value] : [];
    },
    optionCount() {
      const { options: e } = this;
      let t = 0;
      return e.forEach((i) => {
        i[this.groupOptionsKey] ? (t++, i[this.groupOptionsKey].forEach(() => t++)) : t++;
      }), t;
    },
    optionKeys() {
      let { options: e } = this;
      return this.hasGroups && (e = V(this.groupOptionsKey, this.groupLabelKey, this.valueKey, e)), e.map((t) => this.formatOptionLabel(t, this.labelKey).toString());
    },
    selectedLabel() {
      return this.showSelectedValues ? this.multiple ? this.isSearchable ? "" : this.placeholder : this.model.length ? this.getOptionLabel(this.model[0]) : this.isSearchable ? "" : this.placeholder : this.placeholder;
    },
    selectedValue() {
      return this.multiple ? this.model : this.model.length === 0 ? null : this.model[0];
    },
    shouldAnimateSearchEnterExit() {
      return !this.showSelectedValues && (this.taggable || this.multiple) ? this.isSearchable : this.isSearchable && !this.taggable && !this.multiple;
    },
    showSelectedValueTags() {
      return this.showSelectedValues && (this.taggable || this.multiple);
    },
    visibleSelectedValues() {
      return this.multiple && this.showSelectedValues ? this.model.slice(0, this.limit) : [];
    },
    highlightedOption() {
      return (this.hasGroups ? this.flattenedOptions : this.filteredOptions)[this.pointer];
    },
    computedPopperOptions() {
      return !this.taggable || !this.allowEmptyOptions ? this.popperOptions : {
        ...this.popperOptions,
        modifiers: {
          togglePopper: {
            // Run before popper's 'applyStyle' (900)
            order: 899,
            enabled: !0,
            fn: (e) => (this.inputValue.length > 0 ? e.styles.display = "" : e.styles.display = "none", e)
          }
        }
      };
    }
  },
  watch: {
    highlightedOption() {
      this.$emit("highlighted-option-change", this.highlightedOption);
    },
    selectedValuePointer() {
      this.$emit("selected-value-pointer-change", this.visibleSelectedValues[this.selectedValuePointer]);
    },
    filteredOptions() {
      this.$emit("filtered-options-change", this.filteredOptions), this.pointerAdjust();
    },
    options() {
      this.calculateMenuWidthFromOptionLabels(), this.preselectFirst && this.preselect();
    },
    inputValue() {
      this.$emit("input-value-change", this.inputValue, this.id), this.schedulePopperUpdate();
    },
    model() {
      this.stateless && this.model.length && (this.inputValue = "", this.$emit("input", this.multiple ? [] : null)), this.$emit("all-selected-change", this.allOptionsSelected, this.id), this.schedulePopperUpdate();
    },
    loading() {
      !this.loading && this.preselectFirst && this.preselect();
    }
  },
  mounted() {
    this.calculateMenuWidthFromOptionLabels(), this.preselectFirst && this.preselect();
  },
  methods: {
    calculateMenuWidthFromOptionLabels() {
      if (!Array.isArray(this.options) || !this.options.length) {
        this.computedMenuWidth = this.minMenuWidth;
        return;
      }
      const t = (this.hasGroups ? this.flattenedOptions : this.filteredOptions).map((r) => {
        const c = r.type === "group" ? d(r, this.groupLabelKey, "") : this.getOptionLabel(r).toString();
        return {
          type: r.type || "option",
          label: c
        };
      }), i = K(t), s = $(), l = this.extraLabelWidth + 2, h = i + s + l;
      this.computedMenuWidth = Math.round(g(h, this.minMenuWidth, this.maxMenuWidth));
    },
    activate() {
      if (this.isOpen || this.isDisabled)
        return;
      const e = this.hasGroups ? this.flattenedOptions : this.filteredOptions;
      if (this.pointer = a(1, -1, e, this.groupSelect, !1), this.isSearchable) {
        const t = L(this.triggerRef);
        if (t) {
          const i = w(t) * 2;
          this.triggerWidth = t.getBoundingClientRect().width - i;
        }
      }
      this.isOpen = !0, this.$emit("open", this.id);
    },
    deactivate() {
      if (!this.isOpen)
        return;
      let e = !1;
      const t = () => {
        e = !0;
      };
      this.$emit("before-close", { stop: t }), e || (this.$nextTick(() => {
        this.isOpen = !1;
      }), this.preserveSearch || setTimeout(() => {
        this.inputValue = "";
      }, 50), this.$emit("close", this.selectedValue, this.id), this.$formItem && this.$formItem.onFieldBlur(this.model), setTimeout(() => {
        this.$emit("closed");
      }, 150));
    },
    handleBlur() {
      this.isFocused = !1;
    },
    handleFocus() {
      this.isFocused = !0;
    },
    handleHide(e) {
      this.$emit("hide", e, this.id), this.deactivate();
    },
    async handleClickOutside(e) {
      let t = !1;
      const i = () => {
        t = !0;
      };
      e.stop = i, this.$emit("click-outside", e, this.id), t || (await this.$nextTick(), this.deactivate());
    },
    handleKeydown(e, t) {
      const i = this.inputValue.length, s = this.showSelectedValueTags && this.visibleSelectedValues.length, l = this.selectedValuePointer > -1;
      switch (e) {
        case "left":
          !i && s && (this.pointer = -1, this.focusPreviousSelectedValue());
          break;
        case "right":
          !i && s && (this.pointer = -1, this.focusNextSelectedValue());
          break;
        case "up":
          this.resetSelectedValuePointer(), this.pointerBackward();
          break;
        case "down":
          this.resetSelectedValuePointer(), this.pointerForward();
          break;
        case "enter":
          if (l)
            return;
          this.isOpen ? this.addPointerElement() : this.activate();
          break;
        case "esc":
          this.deactivate();
          break;
        case "delete": {
          if (this.showSelectedValues) {
            const h = l ? this.selectedValuePointer : this.model.length - 1;
            this.removeSelectionAtIndex(h);
          }
          break;
        }
        case "space":
          this.isOpen ? i || (this.addPointerElement(), t.preventDefault()) : (this.activate(), t.preventDefault());
          break;
        case "tab":
          this.isOpen && (this.pointer > 0 && this.addPointerElement("tab"), this.deactivate());
          break;
      }
    },
    handleTriggerClick(e) {
      e.detail !== 0 && this.toggleMenu();
    },
    isEntireGroupSelected(e) {
      return e[this.groupOptionsKey].every((t) => this.isOptionSelected(t));
    },
    isNewOption(e) {
      return m(this.isValidNewOption) ? this.isValidNewOption(e) : this.options ? !this.optionKeys.includes(e) : !0;
    },
    isOptionSelected(e) {
      return o(e) ? this.model.some((t) => t[this.valueKey] === e[this.valueKey]) : this.model.includes(e);
    },
    getOptionLabel(e) {
      if (n(e))
        return "";
      if (e.isTag)
        return e.label;
      const t = this.formatOptionLabel(e, this.labelKey);
      return n(t) ? "" : t;
    },
    getOptionValue(e) {
      return o(e) ? e[this.valueKey] : e;
    },
    preselect() {
      if (!this.model.length && this.options.length) {
        const e = this.hasGroups ? this.flattenedOptions : this.filteredOptions, t = a(1, -1, e, this.groupSelect, !1);
        e[t] && this.select(e[t], null, !0);
      }
    },
    select(e, t, i = !1) {
      const s = this.blockKeys.includes(t), l = e && e.disabled, h = this.isDisabled;
      if (!((s || h || l) && !i)) {
        if (e && e.type === "group") {
          if (!this.groupSelect)
            return;
          this.selectGroup(e);
        } else Array.isArray(e) || this.selectSingle(e);
        this.closeOnSelect && this.deactivate();
      }
    },
    selectGroup(e) {
      const t = this.filteredOptions.find((i) => i[this.groupLabelKey] === e[this.groupLabelKey]);
      if (t)
        if (this.isEntireGroupSelected(t)) {
          this.$emit("remove", t[this.groupOptionsKey], this.id);
          const i = this.model.filter((s) => !t[this.groupOptionsKey].includes(s));
          this.$emit("input", i, this.id);
        } else {
          const i = t[this.groupOptionsKey].filter(p(this.isOptionSelected));
          this.$emit("select", i, this.id), this.$emit("input", this.model.concat(i), this.id);
        }
    },
    selectSingle(e, t) {
      const i = this.max && this.multiple && this.model.length === this.max;
      if (!(O(e) || i))
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.closeOnSelect && !this.multiple && this.deactivate(), this.inputValue = "";
        else {
          if (this.isOptionSelected(e)) {
            t !== "tab" && this.removeSelection(e);
            return;
          }
          this.$emit("select", e, this.id), this.multiple ? this.$emit("input", this.model.concat([e]), this.id) : this.$emit("input", e, this.id), this.clearOnSelect && setTimeout(() => {
            this.inputValue = "";
          }, 50);
        }
    },
    removeSelectionAtIndex(e) {
      this.blockKeys.indexOf("Delete") === -1 && this.multiple && this.inputValue.length === 0 && Array.isArray(this.model) && this.model.length && this.removeSelection(this.model[e], !1);
    },
    removeSelection(e, t = !0) {
      if (this.isDisabled || e.disabled)
        return;
      if (!this.allowEmpty && this.model.length <= 1) {
        this.deactivate();
        return;
      }
      const i = o(e) ? this.model.map((s) => s[this.valueKey]).indexOf(e[this.valueKey]) : this.model.indexOf(e);
      if (this.$emit("remove", e, this.id), this.multiple) {
        const s = this.model.slice(0, i).concat(this.model.slice(i + 1));
        this.$emit("input", s, this.id), this.resetSelectedValuePointer();
      } else
        this.$emit("input", null, this.id);
      this.closeOnSelect && t && this.deactivate();
    },
    schedulePopperUpdate() {
      this.isOpen && this.$children[0] && this.$children[0].popperInstance && this.$children[0].popperInstance.scheduleUpdate();
    },
    toggleMenu() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    updateInputValue(e) {
      this.inputValue = e, this.resetSelectedValuePointer();
    },
    addPointerElement(e) {
      const t = this.hasGroups ? this.flattenedOptions : this.filteredOptions;
      if (t.length > 0) {
        let i = t[this.pointer];
        this.taggable && !i && (i = {
          top: t[0],
          bottom: t[t.length - 1]
        }[this.tagPosition]), this.select(i, e);
      }
      this.pointerReset();
    },
    pointerForward() {
      const e = this.hasGroups ? this.flattenedOptions : this.filteredOptions;
      this.shouldScrollToFocusedOption = !0, this.pointer < e.length - 1 ? (this.pointer++, e[this.pointer] && e[this.pointer].type === "group" && !this.groupSelect && this.pointerForward(), e[this.pointer] && e[this.pointer].disabled && this.pointerForward()) : this.pointer = a(1, this.pointer, e, this.groupSelect);
    },
    pointerBackward() {
      const e = this.hasGroups ? this.flattenedOptions : this.filteredOptions;
      this.shouldScrollToFocusedOption = !0, this.pointer > 0 ? (this.pointer--, e[this.pointer] && e[this.pointer].type === "group" && !this.groupSelect && this.pointerBackward(), e[this.pointer] && e[this.pointer].disabled && this.pointerBackward()) : this.pointer = a(-1, this.pointer, e, this.groupSelect);
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0);
    },
    pointerAdjust() {
      const e = this.hasGroups ? this.flattenedOptions : this.filteredOptions;
      this.pointer >= e.length - 1 && (this.pointer = e.length ? e.length - 1 : 0), e.length > 0 && e[this.pointer] && e[this.pointer].type === "group" && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      if (e === -1) {
        this.pointer = -1;
        return;
      }
      const t = this.hasGroups ? this.flattenedOptions : this.filteredOptions;
      t[e] && t[e].type === "group" && !this.groupSelect || this.pointer !== e && (this.shouldScrollToFocusedOption = !1, this.pointer = e);
    },
    resetSelectedValuePointer() {
      this.selectedValuePointer = -1;
    },
    focusNextSelectedValue() {
      const e = this.visibleSelectedValues.length;
      this.selectedValuePointer > -1 && this.selectedValuePointer < e - 1 ? this.selectedValuePointer++ : this.resetSelectedValuePointer();
    },
    focusPreviousSelectedValue() {
      const e = this.visibleSelectedValues.length;
      this.selectedValuePointer === -1 ? this.selectedValuePointer = e - 1 : this.selectedValuePointer > 0 && this.selectedValuePointer--;
    }
  }
};
export {
  B as default
};
//# sourceMappingURL=pendo-multiselect-core.js.map
